import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SplitLanding from './pages/SplitLanding';
import Home from './pages/Home';
import DevHome from './pages/DevHome';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Portfolio from './pages/Portfolio';
import ProjectDetail from './pages/ProjectDetail';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Apps from './pages/Apps';
import AppDetail from './pages/AppDetail';
import AppPolicy from './pages/AppPolicy';
import './App.css';

function App() {
  const location = useLocation();
  const isSplitLanding = location.pathname === '/';

  return (
    <div className="App">
      {!isSplitLanding && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<SplitLanding />} />
          <Route path="/smart-home" element={<Home />} />
          <Route path="/digital" element={<DevHome />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:serviceKey" element={<ServiceDetail />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/portfolio/:slug" element={<ProjectDetail />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/apps" element={<Apps />} />
          <Route path="/apps/:slug" element={<AppDetail />} />
          <Route path="/apps/:slug/privacy" element={<AppPolicy kind="privacy" />} />
          <Route path="/apps/:slug/support" element={<AppPolicy kind="support" />} />
          <Route path="/apps/:slug/terms" element={<AppPolicy kind="terms" />} />
        </Routes>
      </main>
      {!isSplitLanding && <Footer />}
    </div>
  );
}

export default App;
